import { __assign, __read, __rest, __spread } from "tslib";
import _ from 'lodash';
import React, { Fragment } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { Alert, Button, ButtonGroup, Nav, Navbar, NavItem } from 'reactstrap';
import { confirm } from '../ConfirmModal/ConfirmModal';
import { Icon } from '../Icon/Icon';
var DataTableColumnProvider = /** @class */ (function () {
    function DataTableColumnProvider(props) {
        this.props = props;
        this._showActionColumn = this.props.showActionColumn === undefined ? true : this.props.showActionColumn;
        var deleteClick = props.onDeleteClick;
        this._onDeleteClick = function (row) {
            confirm(props.deleteModalProps || { onClose: function () { } }).then(function (result) {
                if (result && deleteClick) {
                    deleteClick(row);
                }
                else {
                    console.log('canceled', JSON.stringify(row));
                }
            });
        };
    }
    DataTableColumnProvider.prototype.getColumnDescriptions = function () {
        var _this = this;
        var columns = [];
        columns.push.apply(columns, __spread(this.props.columnDescriptions));
        if (this._showActionColumn) {
            columns.push({
                dataField: 'actions',
                text: 'Actions',
                isDummyField: true,
                formatter: function (cell, row) {
                    return (React.createElement(ButtonGroup, null,
                        _this.props.extraActions && _this.props.extraActions(row),
                        _this.props.onViewClick && (React.createElement(Button, { onClick: function () { return _this.props.onViewClick && _this.props.onViewClick(row); }, color: "info" },
                            React.createElement(Icon, { name: "eye" }))),
                        _this.props.onEditClick && (React.createElement(Button, { className: 'ml-1', onClick: function () { return _this.props.onEditClick && _this.props.onEditClick(row); }, color: "warning" },
                            React.createElement(Icon, { name: "pen" }))),
                        _this.props.onDeleteClick && (React.createElement(Button, { className: 'ml-1', onClick: function () { return _this._onDeleteClick(row); }, color: "danger" },
                            React.createElement(Icon, { name: "trash-alt" })))));
                }
            });
        }
        return columns;
    };
    return DataTableColumnProvider;
}());
export { DataTableColumnProvider };
export var DataTable = function (_a) {
    var _b = _a.keyField, keyField = _b === void 0 ? 'itemId' : _b, entityState = _a.entityState, columnProvider = _a.columnProvider, onCreateClick = _a.onCreateClick, _c = _a.showCreateButton, showCreateButton = _c === void 0 ? true : _c, leftNav = _a.leftNav, rightNav = _a.rightNav, _d = _a.createButtonText, createButtonText = _d === void 0 ? 'Create' : _d, rest = __rest(_a, ["keyField", "entityState", "columnProvider", "onCreateClick", "showCreateButton", "leftNav", "rightNav", "createButtonText"]);
    var list = [];
    if (_.isArray(entityState.response)) {
        list.push.apply(list, __spread(entityState.response));
    }
    else if (entityState.response) {
        list.push.apply(list, __spread(entityState.response.content));
    }
    list = list.map(function (row) {
        var newRow = __assign({}, row);
        Object.keys(row).forEach(function (key) {
            if (Array.isArray(row[key])) {
                newRow[key] = row[key].join(', ');
            }
        });
        return newRow;
    });
    return (React.createElement("div", null,
        React.createElement(Fragment, null,
            entityState.error && React.createElement(Alert, { color: "danger" }, entityState.error),
            React.createElement(Navbar, { color: "light", light: true },
                React.createElement(Nav, { className: "mr-auto" }, leftNav && leftNav),
                React.createElement(Nav, { className: "ml-auto" },
                    rightNav && rightNav,
                    showCreateButton && (React.createElement(NavItem, null,
                        React.createElement(Button, { color: "secondary", onClick: function () { return onCreateClick && onCreateClick(); } }, createButtonText))))),
            React.createElement(BootstrapTable, __assign({ keyField: keyField, data: list, columns: columnProvider.getColumnDescriptions(), striped: true, hover: true, condensed: true }, rest)))));
};
//# sourceMappingURL=DataTable.js.map